import React from 'react';
import './ClosedAlphaNotice.css';

interface ClosedAlphaNoticeProps {
  onBackToLogin: () => void;
}

const ClosedAlphaNotice: React.FC<ClosedAlphaNoticeProps> = ({
  onBackToLogin,
}) => {
  return (
    <div className="closed-alpha-notice">
      <div className="notice-card">
        <div className="notice-icon" aria-hidden="true">
          <svg
            viewBox="0 0 24 24"
            width="40"
            height="40"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
          >
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
          </svg>
        </div>
        <div className="notice-header">
          <h2>Closed Alpha</h2>
          <div className="notice-badge">Invitation Only</div>
        </div>
        <div className="notice-body">
          <p className="highlight-text">
            Valuera is currently in an exclusive, closed testing phase.
          </p>
          <p>
            Public registration is temporarily closed as we refine the
            experience. If you have been invited to the closed alpha, please log
            in with your assigned test credentials.
          </p>
          <div className="contact-box">
            <span>Need an account? Contact us at:</span>
            <a href="mailto:office@valuera.at" className="contact-link">
              office@valuera.at
            </a>
          </div>
        </div>
        <div className="notice-actions">
          <button type="button" className="login-btn" onClick={onBackToLogin}>
            Go to Login
          </button>
        </div>
      </div>
    </div>
  );
};

export default ClosedAlphaNotice;
